import { useMemo } from 'react';
import type { FC, PropsWithChildren } from 'react';
import { Modal, Popconfirm } from 'antd';
import { CloseOutlined } from '@ant-design/icons';
import classnames from 'classnames/bind';

import styles from './index.module.less';

const cx = classnames.bind(styles);

export type ModalCommonType = {
  onClose: (...args: any) => void;
  width?: number;
};

type BaseModalProps = {
  confirmClose?: boolean;
  className?: string;
} & ModalCommonType;

export const BaseModal: FC<PropsWithChildren<BaseModalProps>> = props => {
  const { className, children, onClose, width = 830, confirmClose = false } = props;

  const closeIco = useMemo(
    () =>
      confirmClose ? (
        <Popconfirm
          title="确认放弃推荐？"
          icon={null}
          onCancel={() => onClose()}
          okText="继续推荐"
          cancelText="放弃推荐"
          placement="bottomRight">
          <span
            style={{
              // 撑满Popconfirm
              display: 'inline-block',
              width: '100%',
              height: '100%',
            }}>
            <CloseOutlined />
          </span>
        </Popconfirm>
      ) : (
        <CloseOutlined />
      ),
    [confirmClose]
  );

  return (
    <Modal
      className={cx('base-modal', className)}
      onCancel={() => {
        !confirmClose && onClose();
      }}
      width={width}
      open={true}
      closeIcon={closeIco}
      footer={null}
      centered>
      {children}
    </Modal>
  );
};

export * from './FormModal';
export * from './ShareModal';
export * from './CheckPhoneModal';
export * from './TableModal';
